import EventActionProto from '../event-action-proto'

export default class SessionRequestFormDelta extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            requestForm : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (_.isEmpty(this.data)) return // no data in event then nothing should be done about it (noticed when deadline is set to same value)

        if (this.isDifferentCompany()) return false

        if (gd.session.requestFormsLoaded) {
            gd.session.requestForms.applyDelta(this.method, this.data)
        }

        gd.modelBus.newUpdate('request-form', this.method, this.header.requestForm.id, this.data, this.header)
    }
}